module.exports = __webpack_public_path__ + "img/8.428121ad.jpg";